<template>
  <div class="parent-box">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container">

              

              <div class="modal-body">
                <div>
      <div class="heading">
        <h2 class="login-title">Confirm Request</h2>
        <p class="text-center">
          Please note, You would be charged from your bank account to get your bank statement, click the button below to continue
        </p>
      </div>
      <div>
        <!-- form elements -->
        

        <!-- real footer item -->
        <div v-if="modalstate" className="text-center">
        <div class="submit-gif ">
        <div class="spinner-border " style="width: 3rem; height: 3rem;" role="status">
  <span class="sr-only">Loading...</span>
</div>
</div>
</div>
<div v-else>
        <button @click="$emit('confirmRequest')"  class="submit-button" type="button">
          Continue to get bank statement
        </button>
        </div>

        
       
      </div>
    </div>
              </div>

            
            </div>
          </div>
        </div>
      </transition>
  </div>
</template>

<script>
import ArnergyInput from "../ArnergyInput";

export default {
  name: "Modal",
  props:['modalstate'],
   components: {
    ArnergyInput,
   
  },
  computed: {},
  data() {
    return {
      form: {
        bvn: ""
      },
      formErrors: {},
      // activeIndex: 0,
      summary: {}
    };
  },

  methods: {
    gotoNextState() {
      // this.$emit("updateStatus");
    }
  },
  async mounted() {}
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/_reduced_variables.scss";

.modal-mask {
  margin-top: 50px;
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 600px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h1 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.submit-button {
  display: block;
  color: white;
  width: 100%;
  text-align: center;
  padding: 15px 32px;
  margin-top: 20px;
  border: 0;
  background-color: $secondary-color;
  font-weight: bold;

  &:hover {
    background-color: darken($secondary-color, 10%);
  }
}
.heading {
  text-align: center;
  margin: auto;
  max-width: 550px;
}


.link {
  color: $primary-color;
  font-weight: bold;
}




.login-title {
  margin-bottom: 40px;
  font-weight: 900;
  font-size: 32px;
  // color: $primary-color;
}

.submit-gif{
   display: block;
  color: white;
  width: 100%;
  text-align: center;
  color:white;
  padding: 15px 32px;
  margin-top: 20px;
  border: 0;
  background-color: $secondary-color;

}



</style>



// WEBPACK FOOTER //
// src/components/pages/kitchen/Onboarding/modal.vue